import deleteAccountTemplate from './deleteAccount.html';

export default angular
  .module('main.profile.tabs.deleteAccount', [])

  .directive('profileDeleteAccountTab', () => {
    return {
      restrict: 'E',
      template: deleteAccountTemplate,
      scope: {},
      controller: (
        $scope,
        $q,
        $filter,
        $interval,
        utils,
        AuthService,
        ProfileDataProvider,
        PermissionsService,
      ) => {
        const $t = $filter('translate');
        $scope.dataProvider = ProfileDataProvider.instance;
        $scope.isUnlimited = PermissionsService.isUnlimitedAdmin();

        angular.extend($scope, {
          onDeleteButtonClick: onDeleteButtonClick,
          onConfirmButtonClick: onConfirmButtonClick,
        });

        init();

        // Remove modals
        $scope.$on('$destroy', () => {
          $('#delete-account-dialog').remove();
        });

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.userInfoResource.init(),
          ])
            .then(() => {
              initDataModel();
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initForm() {
          let username = $scope.user?.userName;
          $('#form-delete-account').form({
            inline: true,
            fields: {
              username: {
                identifier: 'username',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.empty')
                  },
                  {
                    type: 'isExactly',
                    value: username,
                    prompt: $t('profile.deleteAccount.confirmMatch')
                  }
                ]
              },
            }
          });
        }

        function initDataModel() {
          $scope.user = angular.copy($scope.dataProvider.userInfoResource.value?.user);
          initForm();
        }

        function onDeleteButtonClick() {
          if ($scope.isUnlimited || $scope.loading) {
            return;
          }

          $('#delete-account-dialog').modal({
            closable: false,
            onApprove: function() {
              return false;
            }
          }).modal('show');
        }

        function onConfirmButtonClick() {
          $('#form-delete-account').form('validate form');
          if (!$('#form-delete-account').form('is valid')) {
            return;
          }

          $scope.loading = true;
          $('#delete-account-dialog').modal('hide');

          $scope.dataProvider.deleteAdminAccount()
            .then(() => {
              utils.clearCache();
              AuthService.logoutFromThisBrowser();
              window.location.href = '/';
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

      }
    };
  })
  .name;
